import MenuItem from "component/menuitem";

const GuardMenuItems: MenuItem[] = [
]

export default GuardMenuItems;